import React from "react";

export default function Feedback() {
  return (
    <>
      <div id="contact" className="container">
        <h2 className="mt-5 text-center">Contact</h2>
        <hr className="w-25 mx-auto" />
        <form
          action="https://formspree.io/f/xleyrrdg"
          method="POST"
        >
          <div className="mb-3 w-50 mx-auto">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Name
            </label>
            <input
              type="text"
              name="name"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="name"
              autoComplete="off"
              required
            />
          </div>
          <div className="mb-3 w-50 mx-auto">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Email address
            </label>
            <input
              type="email"
              name="email"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="email@gmail.com"
              autoComplete="off"
              required
            />
          </div>
          <div className="mb-3 w-50 mx-auto">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">
              Message
            </label>
            <textarea
              name="message"
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="8"
              autoComplete="off"
              required
              minLength="10"
            ></textarea>
          </div>
          <div className="mb-3 w-50 mx-auto text-center">
            <button
              type="submit"
              value="Submit"
              className="btn btn-primary mb-3"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
